<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="bepc_ouinon" v-model="sasEquivalence.reussiteAuBepc" :live="liveSasEquivalence(6112)" />
    <CatalogueLive
      code="bepc_eval_ouinon"
      :opq-if="estOui(sasEquivalence.reussiteAuBepc)"
      v-model="sasEquivalence.examenDEvaluationBepcReussi"
      :live="liveSasEquivalence(6122)"
    />
    <DatePickerLive
      code="bepc_eval_date"
      v-model="sasEquivalence.dateReussiteExamenDEvaluation"
      :live="liveSasEquivalence(6123)"
      :maxValue="convertDateToString(new Date())"
      :opq-if="estOui(sasEquivalence.examenDEvaluationBepcReussi)"
    />
    <FileInput
      code="bepc_eval_preuve"
      :file="sasEquivalence.preuveExamenDEvaluation"
      :live="liveSasEquivalence(6124)"
      :opq-if="estOui(sasEquivalence.examenDEvaluationBepcReussi)"
      @file-deleted="sasEquivalence.preuveExamenDEvaluation = null"
    />
    <CatalogueLive
      code="bepc_apt1_ouinon"
      :opq-if="estOui(sasEquivalence.reussiteAuBepc)"
      v-model="sasEquivalence.aptitudePartie1Reussie"
      :live="liveSasEquivalence(6125)"
    />
    <DatePickerLive
      code="bepc_apt1_date"
      v-model="sasEquivalence.dateReussiteAptitude1"
      :live="liveSasEquivalence(6126)"
      :maxValue="convertDateToString(new Date())"
      :opq-if="estOui(sasEquivalence.aptitudePartie1Reussie)"
    />
    <FileInput
      code="bepc_apt1_preuve"
      :file="sasEquivalence.preuveAptitude1"
      :live="liveSasEquivalence(6127)"
      :opq-if="estOui(sasEquivalence.aptitudePartie1Reussie)"
      @file-deleted="sasEquivalence.preuveAptitude1 = null"
    />
    <CatalogueLive
      code="bepc_apt2_ouinon"
      :opq-if="estOui(sasEquivalence.reussiteAuBepc)"
      v-model="sasEquivalence.aptitudePartie2Reussie"
      :live="liveSasEquivalence(6128)"
    />
    <DatePickerLive
      code="bepc_apt2_date"
      v-model="sasEquivalence.dateReussiteAptitude2"
      :live="liveSasEquivalence(6129)"
      :maxValue="convertDateToString(new Date())"
      :opq-if="estOui(sasEquivalence.aptitudePartie2Reussie)"
    />
    <FileInput
      code="bepc_apt2_preuve"
      :file="sasEquivalence.preuveAptitude2"
      :live="liveSasEquivalence(6130)"
      :opq-if="estOui(sasEquivalence.aptitudePartie2Reussie)"
      @file-deleted="sasEquivalence.preuveAptitude2 = null"
    />
  </v-form>
</template>


<script>
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasEquivalence() {
      return this.sas.sasEquivalence
    }
  },
  methods: {
    liveSasEquivalence(cle) {
      return { endpoint: "sas-equivalence", cle: cle, fileId: this.sasEquivalence.id }
    }
  }
}
</script>

<style>
</style>